const base_url = "https://shopify-api.masterlock.com";
const ENV = "PROD";

let idologyId = "";
let iQuestions = [];
let validIdForm = true;

function clearErrors() {
    document.getElementById("idology-form-error").innerHTML = "";
      let msgLabels = document.getElementsByClassName("form-error");
    for (let i = 0; i < msgLabels.length; i++) {
        let msgLabel = msgLabels[i];
        msgLabel.innerHTML = "";
    }

}


function pushDataLayerIdology(eventAction, eventLabel) {
  
  var dataLayerObject = {
    'event': 'US Replacements',
    'eventCategory': 'Idology',
    'eventAction': eventAction,
    'eventLabel': eventLabel
  };

  dataLayer.push(dataLayerObject);
}

//Called when a user submits 
function startIdology(e) {
    e.preventDefault();
    console.log("startIdology called");
    const formData = new FormData();

    formData.append("env", ENV);
    formData.append("firstName", document.getElementById("firstName").value);
    formData.append("lastName", document.getElementById("lastName").value);
    formData.append("address", document.getElementById("address").value);
    formData.append("dobYear", document.getElementById("dobYear").value);
    formData.append("zip", document.getElementById("zip").value);

    validateIdologyForm(formData);

  	if(validIdForm) {
      $.ajax({
          url: base_url + "/identity/questions",
          type: 'POST',
          data: formData,
          enctype: 'multipart/form-data',
          cache: false,
          processData: false,
          contentType: false,
          headers: {
              'X-ML-Access-Token': 'mlppa-22j2304924lkjl240234l234'
          }
      }).done(function(data, statusText, xhr) {
          var status = xhr.status;
          if (status === 200) { //200
              pushDataLayerIdology("Customer ID", "Success");
              let jsonData = JSON.parse(data);
              handleInitQuestions(jsonData);
          } else {
              pushDataLayerIdology("Customer ID", "Failure");
              document.getElementById("idology-form-error").innerHTML = "Unable to verify customer information.";
             scrollToTop();
          }
      }).fail(function(jqxhr, settings, ex) {
              pushDataLayerIdology("Customer ID", "Failure");
          document.getElementById("idology-form-error").innerHTML = "Unable to verify customer information.";
         scrollToTop();
      });
  	}

}

function validateIdologyForm(idologyData) {
    clearErrors();
  validIdForm = true;
  
	if (!idologyData.get("firstName")) {
		addIdErrorMessage('firstName', 'Please enter a First Name');
	}
	if (!idologyData.get("lastName")) {
		addIdErrorMessage('lastName', 'Please enter a Last Name');
	}
	if (!idologyData.get("address")) {
		addIdErrorMessage('address', 'Please enter an Address');
	}
	if (!idologyData.get("dobYear")) {
		addIdErrorMessage('dobYear', 'Please enter a Year of Birth');
	}
	if (!idologyData.get("zip")) {
		addIdErrorMessage('zip', 'Please enter a Zip Code');
	}
}



function initIdology() {
    //Hide the initial form and replace with the idology form to collect name
    document.getElementById("replacement-section").style.display = "none";
    document.getElementById("idology-section").style.display = "block";

    //scroll to top
    scrollToTop();
    let idologyBtn = document.getElementById('idology-btn');
    idologyBtn.addEventListener('click', startIdology);

}

function addIdErrorMessage(fieldName, message) {

    validIdForm = false;
    let errorId = fieldName + "-error";
    log(errorId + " -> " + message);
    let errorLabel = document.getElementById(errorId);
    if (errorLabel) {
        errorLabel.innerHTML = message;
    }
}


function submitIdologyAnswers(e) {
    e.preventDefault();
    const answerData = new FormData();

    let q0 = $('input[name=q0]:checked', '#idology-answer-form');
    let q1 = $('input[name=q1]:checked', '#idology-answer-form');
    let q2 = $('input[name=q2]:checked', '#idology-answer-form');
  

    answerData.append("env", ENV);

    answerData.append("idNumber", idologyId);
    answerData.append("question1Type", iQuestions[0]);
    answerData.append("question2Type", iQuestions[1]);
    answerData.append("question3Type", iQuestions[2]);
    answerData.append("question1Answer", q0.val());
    answerData.append("question2Answer", q1.val());
    answerData.append("question3Answer", q2.val());
 

    $.ajax({
        url: base_url + "/identity/questions/response",
        type: 'POST',
        data: answerData,
        enctype: 'multipart/form-data',
        cache: false,
        processData: false,
        contentType: false,
        headers: {
            'X-ML-Access-Token': 'mlppa-22j2304924lkjl240234l234'
        }
    }).done(function(data, statusText, xhr) {
        var status = xhr.status;
        if (status === 200) { //200
          
              pushDataLayerIdology("ID Quiz", "Success");
            addItemToCart();
        }else {
         
              pushDataLayerIdology("ID Quiz", "Failure");
          document.getElementById("idology-form-error").innerHTML = "Unable to verify customer information.";
        }
          
    }).fail(function(jqxhr, settings, ex) {
              pushDataLayerIdology("ID Quiz", "Failure");
        document.getElementById("idology-form-error").innerHTML = "Unable to verify customer information.";
    });


}

function handleInitQuestions(data) {

    //Clear out the ID, just in case
    idologyId = "";

    scrollToTop();
    //swap the header text and hide the Tips section
    document.getElementById("id-text").innerHTML = "Please answer all the questions below to verify your identity before continuing the checkout process.";
    document.getElementById("tips").style.display = "none";

    let idologyForm = document.getElementById("idology-form");
    idologyForm.innerHTML = "";

    idologyId = data["id-number"];
    let questions = data.questions.question;
    const spanArr = [];
    spanArr.push("<form id='idology-answer-form' action='#'>");
  	spanArr.push("<div class='id-form-error text-center' id='idology-form-error'></div>");
    for (var i = 0; i < questions.length; i++) {
        let question = questions[i];
        let answers = question.answer;
        let type = question.type;
        let prompt = question.prompt;
        iQuestions.push(type);
        let spanId = "q" + i;
        spanArr.push("<div id='" + spanId + "' class='question-section'>");
        spanArr.push("<p><strong>" + prompt + "</strong></p>");

        for (var a = 0; a < answers.length; a++) {
            let answer = answers[a];
            let aId = "q" + i + "a" + a;
            let qId = "q" + i;
            spanArr.push("<div class='radio'>");
            spanArr.push("<input type='radio' data-type='" + type + "' name='" + qId + "' value='" + answer + "' id='" + aId + "' class='idology-answer'>");
            spanArr.push("<label class='radio-label' for='" + aId + "'>" + answer + "</label>");
            spanArr.push("</div>");
        }
        spanArr.push("</div>");

    }
    spanArr.push("<div class='ml-spacer'><button id='idology-btn-answer' class='btn btn-replacement'>Submit Answers</button></div></form>");
    let spanTxt = spanArr.join('');

    $('#id-form').html(spanTxt);

    let idologyBtn = document.getElementById('idology-btn-answer');
    idologyBtn.addEventListener('click', submitIdologyAnswers);

}

function challengeQuestions() {
  
    const challengeData = new FormData();
	challengeData.append("idNumber", idologyId);

    clearErrors();

    $.ajax({
        url: base_url + "/identity/challenge",
        type: 'POST',
        data: challengeData,
        enctype: 'multipart/form-data',
        cache: false,
        processData: false,
        contentType: false,
        headers: {
            'X-ML-Access-Token': 'mlppa-22j2304924lkjl240234l234'
        }
    }).done(function(data, statusText, xhr) {
        var status = xhr.status;
        if (status === 200) { //200
            let jsonData = JSON.parse(data);
            handleInitQuestions(jsonData);
        } else {
            document.getElementById("idology-form-error").innerHTML = "Unable to verify customer information.";
        }
    }).fail(function(jqxhr, settings, ex) {
        document.getElementById("idology-form-error").innerHTML = "Unable to verify customer information.";
    });
  
}


function scrollToTop() {

    window.scrollTo(0, 0);
}